export * from './layer-list.component';
export * from './layer-list-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/layer-list/index.ts